import { StyleSheet } from 'react-native';

export const style = StyleSheet.create({
  ctaWrapper: {
    width: '100%',
    flexDirection: 'row',
    gap: 8,
    padding: 16,
    paddingBottom: 16,
  },
});
